import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import axios from "axios";
import config from "../../Common/Configurations/APIConfig";
import { handleSuccess, handleError } from "../../Common/Layout/CustomAlerts";
import LayoutHeader from "../../Common/Layout/Header";
import LayoutSideBar from "../../Common/Layout/Sidebar";
const initialFieldValues = {
  clientServiceId: "00000000-0000-0000-0000-000000000000",
  clientId: "00000000-0000-0000-0000-000000000000",
  categoryId: "00000000-0000-0000-0000-000000000000",
  serviceName: "",
  cycle: "",
};
export default function ClientService() {
  const [lists, setLists] = useState([]);
  const [values, setValues] = useState(initialFieldValues);
  const [recordForEdit, setRecordForEdit] = useState(null);
  const [errors, setErrors] = useState({});
  const [btnSubmit, setBtnSubmit] = useState(true);
  const [totalPages, setTotalPages] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [pageNumber, setPageNumber] = useState(1);
  const [data, setData] = useState([]);
  const [clients, setClients] = useState([]);
  const [categories, setCategories] = useState([]);
  const [totalRecords, setTotalRecords] = useState(0);
  const [services, setServices] = useState([]);
  const userId = localStorage.getItem("userId");
  const headerconfig = {
    headers: {
      Authorization: "Bearer " + localStorage.getItem("userToken"),
    },
  };
  useEffect(() => {
    if (recordForEdit !== null) {
      setValues(recordForEdit);
    }
  }, [recordForEdit]);
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setValues({
      ...values,
      [name]: value,
    });
  };
  const resetForm = () => {
    setValues(initialFieldValues);
    setErrors({});
  };
  const showEditDetails = (data) => {
    setRecordForEdit(data);
  };
  const handleCategoryChange = async (e) => {
    const categoryId = e.target.value;
    setValues({
      ...values,
      categoryId,
      serviceName: "",
      cycle: "",
    });

    try {
      const response = await axios.get(
        config.APIACTIVATEURL + config.GETSERVICESBYCATEGORY + "/" + categoryId,
        headerconfig
      );
      setServices(response.data);
    } catch (error) {
      handleError("Failed to fetch services");
      setServices([]);
    }
  };
  const handleServiceChange = (e) => {
    const selectedService = services.find(
      (s) => s.serviceName === e.target.value
    );

    if (selectedService) {
      setValues({
        ...values,
        serviceName: selectedService.serviceName,
        cycle: selectedService.cycle,
      });
    }
  };
  const GetPageData = (number) => {
    if (number >= 1 && number <= totalPages) {
      setPageNumber(number);
      GetData(number);
    }
  };

  const pageNumbers = [];
  for (let i = 1; i <= totalPages; i++) {
    pageNumbers.push(i);
  }

  const renderPageNumbers = pageNumbers.map((number) => {
    return (
      <li
        className="page-item"
        key={number}
        id={number}
        onClick={() => GetPageData(number)}
      >
        <Link className="page-link">{number}</Link>
      </li>
    );
  });
  const validate = () => {
    let temp = {};
    temp.clientId =
      values.clientId === "00000000-0000-0000-0000-000000000000" ? false : true;
    temp.categoryId =
      values.categoryId === "00000000-0000-0000-0000-000000000000"
        ? false
        : true;
    temp.serviceName = values.serviceName === "" ? false : true;
    setErrors(temp);
    temp.cycle = values.cycle === "" ? false : true;
    setErrors(temp);
    return Object.values(temp).every((x) => x === true);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      setBtnSubmit(false);
      const formData = new FormData();
      formData.append("clientServiceId", values.clientServiceId);
      formData.append("clientId", values.clientId);
      formData.append("categoryId", values.categoryId);
      formData.append("serviceName", values.serviceName);
      formData.append("cycle", values.cycle);
      addOrEdit(formData);
    }
  };
  const applicationAPI = () => {
    return {
      create: (newrecord) =>
        axios.post(
          config.APIACTIVATEURL + config.CREATECLIENTSERVICE,
          newrecord,
          { ...headerconfig }
        ),
      update: (updateRecord) =>
        axios.put(
          config.APIACTIVATEURL + config.UPDATECLIENTSERVICE,
          updateRecord,
          { ...headerconfig }
        ),
    };
  };
  const addOrEdit = (formData) => {
    if (
      formData.get("clientServiceId") === "00000000-0000-0000-0000-000000000000"
    ) {
      applicationAPI()
        .create(formData)
        .then((res) => {
          if (res.data.statusCode === 200) {
            handleSuccess(res.data.data);
            resetForm();
            GetData(pageNumber);
            setBtnSubmit(true);
          } else {
            handleError(res.data.data);
            setBtnSubmit(true);
          }
        })
        .catch(function (error) {
          handleError("Error in saving data");
          setBtnSubmit(true);
        });
    } else {
      applicationAPI()
        .update(formData)
        .then((res) => {
          if (res.data.statusCode === 200) {
            handleSuccess(res.data.data);
            resetForm();
            GetData(pageNumber);
            setBtnSubmit(true);
          } else {
            handleError(res.data.data);
            setBtnSubmit(true);
          }
        })
        .catch(function (error) {
          handleError("Error in updating data");
          setBtnSubmit(true);
        });
    }
  };

  const onDelete = (e, id) => {
    if (window.confirm("Are you sure to delete this record?")) {
      axios
        .delete(config.APIACTIVATEURL + config.DELETECLIENTSERVICE + "/" + id, {
          ...headerconfig,
        })
        .then((response) => {
          if (response.data.statusCode === 200) {
            handleSuccess(response.data.data);
            GetData(pageNumber);
            resetForm();
            GetCategories();
          } else {
            handleError(response.data.data);
            GetData(pageNumber);
            resetForm();
          }
        });
    }
  };
  const GetData = (number) => {
    axios
      .get(
        config.APIACTIVATEURL +
          config.GETCLIENTSERVICE +
          "?pageNumber=" +
          number +
          "&pageSize=" +
          pageSize +
          "",
        { ...headerconfig }
      )
      .then((response) => {
        setLists(response.data.data.data);
        setPageNumber(response.data.data.pageNumber);
        setPageSize(response.data.data.pageSize);
        setTotalPages(response.data.data.totalPages);
        setData(response.data.data);
        setTotalRecords(response.data.data.totalRecords);
      });
  };
  const GetClients = () => {
    axios
      .get(
        config.APIACTIVATEURL + config.GETALLCLIENTS + "?userId=" + userId,
        headerconfig
      )
      .then((response) => {
        setClients(response.data.data);
      });
  };

  const GetCategories = () => {
    axios
      .get(config.APIACTIVATEURL + config.GETTOPLEVELCATEGORIES, headerconfig)
      .then((response) => {
        setCategories(response.data.data);
      });
  };
  const applyErrorClass = (field) =>
    field in errors && errors[field] === false ? " form-control-danger" : "";
  useEffect(() => {
    GetData(pageNumber);
    GetClients();
    GetCategories();
  }, []);
  return (
    <div id="layout-wrapper">
      <LayoutHeader></LayoutHeader>
      <LayoutSideBar></LayoutSideBar>
      <div className="main-content">
        <div className="page-content">
          <div className="container-fluid">
            <div className="row">
              <div className="col-12">
                <div className="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 className="mb-sm-0">Client Service</h4>
                </div>
              </div>
            </div>
            <div className="alert alert-success">
              <form onSubmit={handleSubmit} autoComplete="off" noValidate>
                <div className="row">
                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label htmlFor="clientId" className="form-label">
                        Client
                      </label>
                      <select
                        name="clientId"
                        value={values.clientId}
                        onChange={handleInputChange}
                        className={"form-select " + applyErrorClass("clientId")}
                      >
                        <option value="00000000-0000-0000-0000-000000000000">
                          Select Client
                        </option>
                        {clients.map((c) => (
                          <option key={c.clientId} value={c.clientId}>
                            {c.clientName}
                          </option>
                        ))}
                      </select>
                      {errors.clientId === false && (
                        <div className="validationerror">
                          Please select client
                        </div>
                      )}
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label htmlFor="categoryId" className="form-label">
                        Category
                      </label>
                      <select
                        name="categoryId"
                        value={values.categoryId}
                        onChange={handleCategoryChange}
                        className={
                          "form-select " + applyErrorClass("categoryId")
                        }
                      >
                        <option value="00000000-0000-0000-0000-000000000000">
                          Select Category
                        </option>
                        {categories.map((c) => (
                          <option key={c.categoryId} value={c.categoryId}>
                            {c.categoryName}
                          </option>
                        ))}
                      </select>
                      {errors.categoryId === false && (
                        <div className="validationerror">
                          Please select category
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label htmlFor="serviceName" className="form-label">
                        Service
                      </label>
                      <select
                        name="serviceName"
                        value={values.serviceName}
                        onChange={handleServiceChange}
                        className={
                          "form-select " + applyErrorClass("serviceName")
                        }
                      >
                        <option value="">Select Service</option>
                        {services.map((service) => (
                          <option
                            key={service.systemTaskId}
                            value={service.serviceName}
                          >
                            {service.serviceName} ({service.cycle})
                          </option>
                        ))}
                      </select>
                      {errors.serviceName === false && (
                        <div className="validationerror">
                          Please select service
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="col-lg-3">
                    <div className="mb-3">
                      <label htmlFor="cycle" className="form-label">
                        Cycle
                      </label>
                      <select
                        name="cycle"
                        value={values.cycle}
                        onChange={handleInputChange}
                        className={"form-select" + applyErrorClass("cycle")}
                      >
                        <option value="0">Please Select</option>
                        <option value="Monthly">Monthly</option>
                        <option value="Quarterly">Quarterly</option>
                        <option value="Yearly">Yearly</option>
                        <option value="Single">Single</option>
                      </select>
                      {errors.cycle === false ? (
                        <div className="validationerror">Please select</div>
                      ) : (
                        ""
                      )}
                    </div>
                  </div>
                  <div className="col-lg-3">
                    <div className="hstack gap-2 justify-content-end mb-3 mt-4">
                      {btnSubmit === true ? (
                        <button type="submit" className="btn btn-primary w-100">
                          {values.clientServiceId ===
                          "00000000-0000-0000-0000-000000000000"
                            ? "Submit"
                            : "Update"}
                        </button>
                      ) : (
                        <button
                          type="submit"
                          className="btn btn-primary w-100"
                          disabled
                        >
                          Please wait...
                        </button>
                      )}
                      <button
                        type="button"
                        className="btn btn-danger w-100"
                        onClick={resetForm}
                      >
                        Cancel
                      </button>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="row">
              <div className="col-xl-12">
                <div className="card card-height-100">
                  <div className="card-body">
                    <div className="table-responsive table-card">
                      <table className="table align-middle" id="customerTable">
                        <thead className="table-light">
                          <tr>
                            <th>S.No</th>
                            <th>Client </th>
                            <th>Category </th>
                            <th>Service </th>
                            <th>Cycle</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody className="list form-check-all">
                          {lists.length > 0 &&
                            lists.map((v, index) => (
                              <tr key={v.clientServiceId}>
                                <td>
                                  {(pageNumber - 1) * pageSize + (index + 1)}
                                </td>{" "}
                                <td>{v.clientName}</td>
                                <td>{v.categoryName}</td>
                                <td>{v.serviceName}</td>
                                <td>{v.cycle}</td>
                                <td>
                                  <ul className="list-inline hstack gap-2 mb-0">
                                    <li
                                      className="list-inline-item"
                                      data-bs-toggle="tooltip"
                                      data-bs-trigger="hover"
                                      data-bs-placement="top"
                                      title="Edit"
                                    >
                                      <Link
                                        className="edit-item-btn"
                                        onClick={() => showEditDetails(v)}
                                      >
                                        <i className="ri-pencil-fill align-bottom text-muted" />
                                      </Link>
                                    </li>
                                    <li
                                      className="list-inline-item"
                                      data-bs-toggle="tooltip"
                                      data-bs-trigger="hover"
                                      data-bs-placement="top"
                                      title="Delete"
                                    >
                                      <Link
                                        className="remove-item-btn"
                                        onClick={(e) =>
                                          onDelete(e, v.clientServiceId)
                                        }
                                      >
                                        <i className="ri-delete-bin-fill align-bottom text-muted" />
                                      </Link>
                                    </li>
                                  </ul>
                                </td>
                              </tr>
                            ))}
                        </tbody>
                      </table>
                    </div>
                    <div className="align-items-center mt-4 pt-2 justify-content-between d-flex">
                      <div className="flex-shrink-0">
                        <div className="text-muted">
                          Showing{" "}
                          <span className="fw-semibold">{lists.length}</span> of{" "}
                          <span className="fw-semibold">{totalRecords}</span>{" "}
                          Results
                        </div>
                      </div>
                      <ul className="pagination pagination-separated pagination-sm mb-0">
                        <li
                          className={
                            "page-item " + (pageNumber === 1 ? "disabled" : "")
                          }
                          onClick={() => GetPageData(pageNumber - 1)}
                        >
                          <Link className="page-link">Previous</Link>
                        </li>

                        {renderPageNumbers}

                        <li
                          className={
                            "page-item " +
                            (pageNumber === totalPages ? "disabled" : "")
                          }
                          onClick={() => GetPageData(pageNumber + 1)}
                        >
                          <Link className="page-link">Next</Link>
                        </li>
                      </ul>
                    </div>
                  </div>
                </div>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
